export function BrowserUtils(debugEnabled){

  function getCookieValue(cookieNamePrefix) {
    if (typeof document.cookie !== "string") return undefined;
    return document.cookie.split(";")
      .filter(el => typeof el === "string")
      .map(el => el.trim())
      .filter(el => el.indexOf(cookieNamePrefix) === 0)
      .map(el => el.substring(el.indexOf("=") + 1))
      .shift();
  }

  function getDatalayerValue(key) {
    if (!Array.isArray(window.dataLayer)) return undefined;
    return window.dataLayer
      .filter(el => typeof el === "object" && el.hasOwnProperty(key))
      .map(el => el[key])
      .shift();
  }

  function getMetaTagContent(propertyName) {
    let metaTagContent = undefined;
    const metaTag = document.querySelector('meta[property="' + propertyName + '"]');
    if (metaTag) {
      metaTagContent = metaTag.getAttribute("content");
    }
    return metaTagContent;
  }

  function removeEmptyUtmParameters(customUrl) {
    function removeEmptyParameter(searchParams, paramName) {
      const currValueArray = searchParams.getAll(paramName);
      searchParams.delete(paramName);
      const newValue = currValueArray.filter(value => value && value.length > 0).shift();
      if (debugEnabled) console.log('BrowserUtils: set UTM param value', paramName, currValueArray, newValue);
      if (newValue) {
        searchParams.set(paramName, newValue);
      }
    }

    if (URL && URLSearchParams) {
      const customUrlObject = new URL(customUrl);
      removeEmptyParameter(customUrlObject.searchParams, 'utm_campaign');
      removeEmptyParameter(customUrlObject.searchParams, 'utm_source');
      removeEmptyParameter(customUrlObject.searchParams, 'utm_medium');
      removeEmptyParameter(customUrlObject.searchParams, 'utm_content');
      removeEmptyParameter(customUrlObject.searchParams, 'utm_term');
      if (debugEnabled) console.log('BrowserUtils: cleaned UTM param search string', customUrlObject.searchParams.toString());
      return customUrlObject.toString();
    } else {
      //IE11 might nog have these objects
      return customUrl;
    }
  }

  return {
    getCookieValue: getCookieValue,
    getDatalayerValue: getDatalayerValue,
    getMetaTagContent: getMetaTagContent,
    removeEmptyUtmParameters: removeEmptyUtmParameters
  }
}
